import {Component, OnInit} from '@angular/core';
import {ITela} from "../../objeto/ITela";
import {AvaliacaoService} from "../../services/avaliacao.service";

// Avaliações que o dono publicou na loja, da mais recente para a mais antiga.
@Component({
  selector: 'app-tela-avaliacoes-loja',
  templateUrl: './tela-avaliacoes-loja.component.html',
  styleUrls: ['./tela-avaliacoes-loja.component.scss']
})
export class TelaAvaliacoesLojaComponent implements OnInit, ITela {
  avaliacoes: Array<any> = [];
  media = 0;
  total = 0;
  carregando = false;
  carregou = false;
  erro = '';
  estrelas = [1, 2, 3, 4, 5];
  private tamanhoPagina = 10;

  constructor(private avaliacaoService: AvaliacaoService) { }

  ngOnInit(): void {
    this.carregueMais();
  }

  deveExibirTopo() {
    return false;
  }

  deveExibirMenu() {
    return false;
  }

  deveTerBordas() {
    return true;
  }

  deveExibirBannerTema() {
    return false;
  }

  get temMais() {
    return this.avaliacoes.length < this.total;
  }

  carregueMais() {
    if (this.carregando) return;

    this.carregando = true;
    this.erro = '';

    this.avaliacaoService.listePublicas(this.avaliacoes.length, this.tamanhoPagina).then((resposta: any) => {
      this.carregando = false;
      this.carregou = true;
      this.media = resposta?.media || 0;
      this.total = resposta?.total || 0;
      this.avaliacoes = this.avaliacoes.concat(resposta?.avaliacoes || []);
    }).catch(() => {
      this.carregando = false;
      this.carregou = true;
      this.erro = 'Não conseguimos carregar as avaliações agora.';
    });
  }

  percentualEstrelas(media: number) {
    return Math.max(0, Math.min(100, (Number(media) || 0) / 5 * 100));
  }

  inicial(nome: string) {
    return (nome || 'C').charAt(0).toUpperCase();
  }

  // "hoje", "ontem", "há 3 dias", "há 2 semanas", "há 5 meses"; a data é só o dia (sem horário).
  dataRelativa(data: any) {
    if (!data) return '';

    const [ano, mes, dia] = String(data).slice(0, 10).split('-').map(Number);
    const hoje = new Date();
    const dias = Math.round((Date.UTC(hoje.getFullYear(), hoje.getMonth(), hoje.getDate()) - Date.UTC(ano, mes - 1, dia)) / 86400000);

    if (dias <= 0) return 'hoje';
    if (dias === 1) return 'ontem';
    if (dias < 7) return `há ${dias} dias`;
    if (dias < 30) return Math.floor(dias / 7) === 1 ? 'há 1 semana' : `há ${Math.floor(dias / 7)} semanas`;
    if (dias < 365) return Math.floor(dias / 30) === 1 ? 'há 1 mês' : `há ${Math.floor(dias / 30)} meses`;

    return Math.floor(dias / 365) === 1 ? 'há 1 ano' : `há ${Math.floor(dias / 365)} anos`;
  }
}
